import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import S from 'string';
import accounting from 'accounting';
import APIClient from '../../client';
import InfiniteScroll from 'react-infinite-scroll-component';
import HeaderView from '../../widgets/header';
import GroupMenuView from '../../widgets/groupmenu';
import FooterView from '../../widgets/footer';
import './style.css';

const PAGE_LIMIT = 10;

class View extends Component {
  constructor(params) {
    super(params);
    this.state = {

      item:             null,
      items:            [],
      locality:         params.locality,
      user:             params.user,
      groupuid:         (params.match.params || {}).groupuid || null,
      section:          'loading',
      hasMore:          true,
      offset:           0
      
    };
    this.handleUserChange = params.handleUserChange;
    this.inputSearchQuery = React.createRef();
  }
  onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    this.setState(state => {
      const rows = state.rows.slice();
      for (let i = fromRow; i <= toRow; i++) {
        rows[i] = { ...rows[i], ...updated };
      }
      return { rows };
    });
  }
  componentDidMount = async () => {

    // set the groups
    document.title = '' + this.state.groupuid;

    // get the token
    let token = APIClient.getToken();

    // set the call
    let result = null;

    // handle errors
    try {
      result = await APIClient.call({

        path:   '/groups/' + this.state.groupuid,
        query:  {
          token
        }
  
      });
    } catch(err) {
      this.setState({
        section: 'error'
      });
      return;
    }

    if(result.ok !== true) {
      this.setState({
        section: 'notfound'
      });
      return;
    }

    // set the groups
    document.title = 'Records / ' + result.data.name;

    // handle the item
    this.setState({

      item:         result.data

    }, async () => {

      // load the records
      await this.fetchItems();

      // set the state
      this.setState({

        section:      'view',

      })

    });

  }
  fetchItems = async () => {

    // get the token
    let token = APIClient.getToken();

    // get the items
    let items = [];

    // set the items
    let query = {
      token,
      limit: PAGE_LIMIT,
    };

    // add params
    if(S(this.state.search).isEmpty() === false) {
      query.q = this.state.search;
    }

    // handle errors
    try {
      let result = await APIClient.call({

        path:   '/groups/' + this.state.item.slug + '/records',
        query:  query
  
      });
      items = result.data || [];
    } catch(err) {
      this.setState({
        errorMessage: 'Problem getting the new items'
      })
    }

    // set the item
    this.setState({
      items
    })

  }
  handleSearchQueryChange = () => {
    if(this.timer) clearTimeout(this.timer);
    this.setState({
      search: this.inputSearchQuery.current.value
    }, () => {
      this.timer = setTimeout(this.handleResetSearch, 100);
    });
  }
  handleResetSearch = () => {
    this.setState({
      
      limit:    PAGE_LIMIT,
      offset:   0,
      hasMore:  true

    }, this.fetchItems);
  }
  handleNext = async () => {
    let offset = this.state.offset + PAGE_LIMIT;

    // get the token
    let token = APIClient.getToken();

    // pulled items
    let pulleditems = [];

    // set the items
    let query = {
      token,
      offset: offset,
      limit: PAGE_LIMIT,
    };

    // add params
    if(S(this.state.search).isEmpty() === false) {
      query.q = this.state.search;
    }

    // handle errors
    try {
      let result = await APIClient.call({

        path:   '/groups/' + this.state.item.slug + '/records',
        query:  query
  
      });
      pulleditems = result.data || [];
    } catch(err) {
      this.setState({
        errorMessage: 'Problem getting the new items'
      })
    }

    let items = (this.state.items || []).concat(pulleditems || []);

    // set the item
    this.setState({
      items:    items,
      offset:   offset,
      hasMore:  pulleditems.length === PAGE_LIMIT
    })
  }
  renderItems = () => {

    if(this.state.item.records > 0 && this.state.items.length > 0) {

      return (<div className="grouprecords-listing-items">
        {
          this.state.items.map((item) => {
            return <div className="grouprecords-listing-item">
              <Link className="grouprecords-listing-item-inner" to={'/groups/' + this.state.item.slug + '/records/' + item.uid}>
                <div className='grouprecords-listing-item-inner-header'></div>
                <div className="grouprecords-listing-item-preview">
                <img className="grouprecords-listing-item-image" alt={'#' + item.microchip} src={item.image || 'https://cdn.chipndoodle.com/defaults/record.png'} />
                </div>
                <div className="grouprecords-listing-item-meta">
                  <h3>{item.nickname}</h3>
                  <p>#{item.uid}</p>
                </div>
                <div className="clearfix"></div>
              </Link>
            </div>;
          })
        }
      </div>);

    } else if(this.state.item.records === 0) {

      return (<div className="grouprecords-items-blank">
        <span className="fas fa-paw"></span>
        <p>No records have been created for this group, create your first now or import all your existing records!</p>
        <div className="clearfix"></div>
      </div>);

    } else {

      return (<div className="grouprecords-items-blank">
        <span className="fas fa-search-minus"></span>
        <p>No records found matching that search</p>
        <div className="clearfix"></div>
      </div>);

    }
  }
  render() {
    if(this.state.section === 'loading') {
      return (
        <div className="wrapper initialoading-wrapper-bg">
          <HeaderView {...this.props} locality={this.state.locality}  user={this.state.user} state={this.state} />
          <div className="initialoading-inside-wrapper">
            <div className="initialoading">
              <div className="dots">
                <div className="dot dot1"></div>
                <div className="dot dot2"></div>
                <div className="dot dot3"></div>
                <div className="dot dot4"></div>
                <div className="dot5"></div>
              </div>
              <h2 className="initialoading-heading">One sec just loading...</h2>
            </div>
          </div>
          <FooterView locality={this.state.locality} state={this.state} />
        </div>);
    } else if(this.state.section === 'error') {
      return (<div className="wrapper">
                <div className="grouprecords">
                  <div className="container">
                    <div className="grouprecords-inner">
                      <p>Something went wrong</p>
                    </div>
                  </div>
                </div>
              </div>);
    } else if(this.state.section === 'notfound') {
      return (<div>
        <HeaderView {...this.props} section="me" locality={this.state.locality}  user={this.state.user} state={this.state} />
        <div className="wrapper">
          <div className="grouprecords">
            <div className="container">
              <div className="grouprecords-inner">

                <p>No such group or you are not allowed to access</p>

                <div className="clearfix"></div>

              </div>
            </div>
          </div>
        </div>
        <FooterView locality={this.state.locality} state={this.state} />
      </div>);
    }
    return (
      <div>
        <HeaderView {...this.props} locality={this.state.locality}  user={this.state.user} state={this.state} />
        <GroupMenuView user={this.state.user} group={this.state.item} section="records"></GroupMenuView>
        <div className="wrapper">
          <div className="grouprecords">
            <div className="container">
              <div className="grouprecords-inner">

              <InfiniteScroll 
                  dataLength={this.state.items.length} //This is important field to render the next data
                  next={this.handleNext}
                  hasMore={this.state.hasMore} 
                  style={{
                    overflow: 'visible'
                  }}
                  loader={<h4 style={{textAlign: 'center', marginTop: 25}}>Loading more searches...</h4>}
                  endMessage={
                    this.state.items.length > PAGE_LIMIT
                    ?
                      <p style={{textAlign: 'center', marginTop: 25}}>
                        <b>No more records found :)</b>
                      </p>
                    : 
                      null
                  }
                  // below props only if you need pull down functionality
                  refreshFunction={this.handleResetSearch} >

                  <div className="clearfix"></div>

                  <h1 className="grouprecords-heading">Manage your records</h1>
                  <p className="grouprecords-heading-slogan">That's about {accounting.formatNumber(this.state.item.records)} records in total ;)</p>

                  <div className="clearfix"></div>

                  <div className="grouprecords-ctas">
                    <Link className="grouprecords-cta" to={"/groups/" + this.state.groupuid + "/new"}>New Record</Link>
                    <Link className="grouprecords-cta" to={"/groups/" + this.state.groupuid + "/import"}>Import Records</Link>
                    <div className="clearfix"></div>
                  </div>

                  <div className="clearfix"></div>

                  <div className="grouprecords-filter-form">
                    <input onChange={this.handleSearchQueryChange} defaultValue={this.state.search} ref={this.inputSearchQuery} type="text" placeholder="Filter searches using email, microchip number, city etc" />
                  </div>
                  <div className="clearfix"></div>
                  {this.renderItems()}
                  <div className="clearfix"></div>

                </InfiniteScroll>

              </div>
            </div>
          </div>
        </div>
        <FooterView locality={this.state.locality} state={this.state} />
      </div>
    );
  }
}

export default View;